import SidebarBrand from "@/components/SidebarBrand/SidebarBrand.vue";
import SidebarUserFooter from "@/components/SidebarUserFooter/SidebarUserFooter.vue";

export default {
  name: "SidebarShell",

  components: {
    SidebarBrand,
    SidebarUserFooter
  },

  props: {
    logo: {
      type: String,
      required: true
    },
    brand_title: {
      type: String,
      default: "Enter Brand Name"
    },
    brand_subtitle: {
      type: String,
      default: "Enter Brand Subtitle"
    },
    initials: {
      type: String,
      default: "GU"
    },
    full_name: {
      type: String,
      default: "Guest User"
    }
  }
};
